export default "__VITE_ASSET__71f6ad5e__"